import { FilterSelect } from "components/form-elements/FilterSelect";
import React, { ReactElement } from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import { getSelectSections } from "./getSelectSections";

type Props = { isHomepage?: boolean };

export const BrandFilter = ({ isHomepage }: Props): ReactElement => {
    const counts = useCount("merken");
    const brands = useFilter("merken");

    return (
        <FilterSelect
            fieldName="merkIds"
            label="Merk"
            isMulti
            options={getSelectSections(brands, counts)}
            notAvailableMessage="Merk is niet beschikbaar"
            ariaLabel="Merk"
            isHomepage={isHomepage}
        />
    );
};
